module.exports = __webpack_public_path__ + "static/media/ev-homepage.5f0cabe5.png";